/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Checks if a user has editor or admin access in a certain organization or bot.
 *
 * @returns {String} Returns the base url of the current environment
 */
const generateEnvironmentUrl = () => {
  const currentUrl = window.location.href;
  const baseUrl = currentUrl.split('/org/')[0];

  return baseUrl;
};

export default generateEnvironmentUrl;

